import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as CloseIcon } from '@assets/icons/close-chip.svg';

import { clearGlobalFilter } from '@store/actions/FilterAction';
import { setDescriptionSearchText } from '@store/supplier/action';

const ChipForDescriptionSearch = () => {
	const dispatch = useDispatch();
	const { descriptionSearchText } = useSelector((store) => store?.supplier?.fabricSearch);

	const onClearAll = () => {
		dispatch(clearGlobalFilter());
		dispatch(setDescriptionSearchText(''));
	};

	return (
		<div>
			<div className="chip-container fdgdaghfadh">
				<div className="chips">
					<div className="chip">
						<span>{descriptionSearchText}</span>
						<span className="chip-close cursor-pointer" onClick={onClearAll}>
							<CloseIcon />
						</span>
					</div>
					<span className="clear" onClick={onClearAll}>
						Clear all
					</span>
				</div>
			</div>
		</div>
	);
};

export default ChipForDescriptionSearch;
